import { TShare } from '../../share.model';

export function togglePointRelationshipsAccessLogic(share: TShare): boolean {
  let pointRelationshipsPermission = share.advancedAccessLevels.pointsRelationships.permission.edit;

  pointRelationshipsPermission = !pointRelationshipsPermission;

  return pointRelationshipsPermission;
}
